import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Caseta, Turno, Usuario } from 'src/app/models';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { AsignarFondoService } from 'src/app/services/asignar-fondo.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { NotificacionesPushService } from 'src/app/services/notificaciones-push.service';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { DevolucionService } from 'src/app/services/devolucion.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cuadrar-fondo',
  templateUrl: './cuadrar-fondo.component.html',
  styleUrls: ['./cuadrar-fondo.component.scss']
})
export class CuadrarFondoComponent implements OnInit {
  modalConfirmacion:boolean = false;
  usuario:Usuario;
  id_fondo:number;
  caseta:Caseta;
  formFondoDenominacion:FormGroup;
  totalBoveda:number = 0;
  jefesTurno:any[];
  turnos:Turno[];
  nameTurnos = {
    1:'NOCTURNO',
    2:'MATUTINO',
    3:'VESPERTINO'
  };
  id_devolucion:number = 0;
  tipoDevolucion:string = '';
  fondoCabinas = {
    casetaTroncal : [],
    totalCasetaTroncal :0,
    fondoCasetasAuxiliares:[]
  };
  fondoMorralla = {
    fondoCabina: [], //array de nombre cabina y fondo
    totalFondo : 0
  }
  constructor(
    private store : Store<AppState>,
    private fondoDenominacionService: AsignarFondoService,
    private devolucionService: DevolucionService,
    private toastr: ToastrService,
    private notificacionCasetaService: NotificacionesPushService,
    private ngxUiLoaderService : NgxUiLoaderService,
    private fb:FormBuilder,
   ) { }

  ngOnInit(): void {
    this.getDataUsuario();
    this.getFondo();
    this.getFondosByTipo();
    this.createFormFondoDinamico();
  }

  getDataUsuario() {
    this.store.select(selectUser).subscribe(usuario => {
      this.usuario = usuario;
      this.id_fondo = this.usuario.caseta_usuario[0].id_fondo;
      this.caseta = this.usuario.caseta_usuario.find((caseta) => caseta.tipo === 1);
    });
  }

  //SECCION DE FONDO
  createFormFondoDinamico() {
    this.formFondoDenominacion = this.fb.group({
      denominaciones: this.fb.array([])
    });
  }

  getFondo(){
    this.ngxUiLoaderService.start();
    this.fondoDenominacionService.getFondo(this.id_fondo)
    .subscribe(fondo => {
      fondo.fondoDenominacion.forEach(denominacion => {
        let cantidadFondo = denominacion.pivot.cantidad; //cantidad de billetes o monedas
        this.agregarDenominacionArray({ id: denominacion.pivot.id, denominacion:denominacion.cantidad, cantidadFondo: cantidadFondo}); //cantidad - total
      });
      this.obtenerValores();
      this.calcularTotalBoveda();
      this.ngxUiLoaderService.stop();
    });
  }

  get denominaciones(): FormArray {
    return this.formFondoDenominacion.get('denominaciones') as FormArray;
  }

  agregarDenominacionArray(valor: any): void {
    const formGroup = this.fb.group({
      id_denominacion : new FormControl(valor.id),
      denominacion: new FormControl(valor.denominacion),  // FormControl para 'denominacion'
      cantidadFondo: new FormControl(valor.cantidadFondo)  // FormControl para 'cantidadFondo'
    });

    formGroup.get('cantidadFondo')?.valueChanges.subscribe(nuevaCantidad => {  //actualizamos el valor en el formulario
      formGroup.get('cantidadFondo')?.setValue(nuevaCantidad, { emitEvent: false });
      this.calcularTotalBoveda();
    });

    this.denominaciones.push(formGroup);
  }

  calcularTotalBoveda(){
    this.totalBoveda = 0;
    this.denominaciones.value.forEach(denominacion => {
      this.totalBoveda += (Number(denominacion.cantidadFondo) * Number(denominacion.denominacion));
    });
  }

  async actualizarFondo(){ //modificar la cantidad por denominacion del fondo
    let form = {...this.formFondoDenominacion.value, 'fondo': this.id_fondo};
    this.ngxUiLoaderService.start();
    try {
      let denominacionUpdate:any = await this.fondoDenominacionService.updateFondoDenominacion(form);
      this.toastr.success(`${denominacionUpdate.msj}`, 'Correcto', {positionClass: 'toast-bottom-right'});
      console.log(denominacionUpdate);
    } catch (error) {
      console.log(error);
    }
    this.ngxUiLoaderService.stop();
  }
  //FIN FONDO

  //SECCION FONDO EN CABINAS
  getFondosDevueltosCabinasAuxiliares(){ //PENDIENTE POR CALCULAR
    this.ngxUiLoaderService.start();
    this.devolucionService.getDenominacionAuxiliarMonto().subscribe(auxiliar => { //OBTIENE TODAS LAS DENOMINACIONES
      console.log(auxiliar);
      this.ngxUiLoaderService.stop();
    });
  }

  getFondosByTipo() {
    let tipo_evento = ['fondo', 'morralla']; //4 = solicitud de fondo, 7 = solicitud de morralla
    for (let i = 0; i < 2; i++) {
      this.notificacionCasetaService.getFondoByTipo({'tipo_fondo':tipo_evento[i]})
      .subscribe(cortes => {
         this.getTotalFondosByTipoEvento(tipo_evento[i], cortes);
      });
    }

  }

  //GET : FONDO EN CABINAS Y FONDO MORRALLA
  getTotalFondosByTipoEvento(tipo_evento,cortes) {
    if (tipo_evento == 'fondo') {
      this.fondoCabinas.totalCasetaTroncal = cortes.filter(corte => corte.tipo_caseta == 1 && corte.fondo != null)
      .reduce((acc, corte)=> {
        this.fondoCabinas.casetaTroncal.push({'id_devolucion': corte.id_c_devolucion ,'cabina' : corte.nombre, 'fondo': corte.fondo, 'fecha_hora': corte.fecha_hora});
        return acc + corte.fondo;
      }, 0);
    }else{
      this.fondoMorralla.totalFondo = cortes.filter(corte => corte.fondo != null)
        .reduce((acc, cabina)=> {
          this.fondoMorralla.fondoCabina.push({'id_devolucion': cabina.id_c_devolucion ,'cabina' : cabina.nombre, 'fondo': cabina.fondo , 'fecha_hora': cabina.fecha_hora});
          return acc + cabina.fondo;
        }, 0)
    }
  }

  resetFondos() {
    this.fondoCabinas = {
      casetaTroncal: [],
      totalCasetaTroncal: 0,
      fondoCasetasAuxiliares: []
    };

    this.fondoMorralla = {
      fondoCabina: [],
      totalFondo: 0
    };
  }

  changeValueModal(id_devolucion = 0,tipo = '') {  //MODAL PARA CONFIRMAR SI MODIFICAMOS O NO
    this.modalConfirmacion = !this.modalConfirmacion;
    this.id_devolucion = this.modalConfirmacion ? id_devolucion : 0;
    this.tipoDevolucion = this.modalConfirmacion ? tipo : '';
  }

  updateDevolucion(){
   if (this.id_devolucion != 0) {
    this.ngxUiLoaderService.start();
    this.devolucionService.updateTipoDevolucion(this.id_devolucion)
    .subscribe((res)=>{
      if (res.code == 200) {
       this.eliminarCabinaArrayFondos();
       this.changeValueModal();
       this.ngxUiLoaderService.stop();
       this.toastr.success(`${res.msj}, Modificación Correcta`);
      }
    });
   }
  }

  eliminarCabinaArrayFondos(){
    const array = this.tipoDevolucion == 'fondo' ? this.fondoCabinas.casetaTroncal : this.fondoMorralla.fondoCabina;
    let total = this.tipoDevolucion == 'fondo' ? 'totalCasetaTroncal' : 'totalFondo';
    const indice = array.findIndex(cabina => cabina.id_devolucion === this.id_devolucion);
      if (indice !== -1) {
        this[this.tipoDevolucion == 'fondo' ? 'fondoCabinas' : 'fondoMorralla'][total] -= array[indice].fondo;
        array.splice(indice, 1);
      }
  }

  obtenerValores(): void {
    console.log(this.formFondoDenominacion.value); // Muestra todos los valores de los inputs
    console.log(this.denominaciones);
  }

}
